export const Endpoints = {
  apiRoot: process.env.REACT_APP_API_ROOT,
}

export const getBaseHeaders = (): HeadersInit => {
  return {
    'content-type': 'application/json;charset=UTF-8',
  }
}
